const config = {
  env: process.env.REACT_APP_ENV,
  baseUrl: process.env.REACT_APP_BASE_URL,
  apiUrl: process.env.REACT_APP_API_URL,
  thawaniUrl: process.env.REACT_APP_THAWANI_URL,
  thawaniConfig: {
    'thawani-api-key': process.env.REACT_APP_THAWANI_API_KEY,
    publishable_key: process.env.REACT_APP_THAWANI_PUBLISHABLE_KEY,
  },
  thawaniPaymentUrl: process.env.REACT_APP_THAWANI_PAY_URL,
  paymentSuccessUrl: process.env.REACT_APP_PAYMENT_SUCCESS_URL,
  paymentSuccessUrlBulk: process.env.REACT_APP_PAYMENT_SUCCESS_URL_BULK,
  paymentCancelledUrl: process.env.REACT_APP_PAYMENT_CANCELLED_URL,
  walletPaymentSuccessUrl: process.env.REACT_APP_WALLET_PAYMENT_SUCCESS_URL,
  walletPaymentCancelledUrl: process.env.REACT_APP_WALLET_PAYMENT_CANCELLED_URL,
  clientPaymentSuccessUrl: process.env.REACT_APP_CLIENT_PAYMENT_SUCCESS_URL,
  clientPaymentCancelledUrl: process.env.REACT_APP_CLIENT_PAYMENT_CANCELLED_URL,
  scopeUrl: process.env.REACT_APP_BASE_URL,
  imageUrl: process.env.REACT_APP_IMAGE_URL,
};

export const {
  imageUrl,
  apiUrl,
  thawaniUrl,
  thawaniConfig,
  thawaniPaymentUrl,
  paymentSuccessUrl,
  paymentSuccessUrlBulk,
  paymentCancelledUrl,
  walletPaymentSuccessUrl,
  walletPaymentCancelledUrl,
  clientPaymentSuccessUrl,
  clientPaymentCancelledUrl,
  baseUrl,
  scopeUrl,
} = config;
